import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { BaseBackendService } from './base-backend.service';
import { SsoAuthService } from './sso.service';
import { BaseModel } from './base.model';

class ExternalUrl extends BaseModel {
    constructor() {
        super();
    }
}

@Injectable({
    providedIn: 'root',
})
export class ExternalUrlServiceService extends BaseBackendService<ExternalUrl> {
    constructor(
        http: HttpClient,
        authService: AuthService,
        ssoService: SsoAuthService
    ) {
        super(http, authService, ExternalUrl, 'validate_url', ssoService);
    }

    get URL() {
        return this.apiURL;
    }
}
